import useIPA from '@/auth/jwt/useJwt'
import router from '@/router/index.js'

// initial state
const state = () => ({
  perPage: 5,
  pageOptions: [3, 5, 10],
  totalRows: 1,
  sortOptions: [],
  fields: [
    {
      key: 'level', label: 'Level',
    },
    { key: 'code', label: 'Code', sortable: true },
    { key: 'name', label: 'Name', sortable: true },
    { key: 'icon', label: 'Icon' },
    { key: 'slug', label: 'Slug' },
    { key: 'url', label: 'Url' },
    { key: 'created_at', label: 'Created At' },
    { key: 'status', label: 'Status', sortable: true },
    { key: 'action', label: 'Action' },
  ],
  items: [],
  options: [],
  itemsTree: [],
})

// getters
const getters = {}

// actions
const actions = {
  getAll({ commit }, params) {
    const param = { status: 'master/privileges', params }
    useIPA.get(param).then(response => {
      const privilegeCategory = {
        rows: response.data.data,
      }
      const { pagination } = response.data
      commit('setData', { ...privilegeCategory })
      commit('setPagination', pagination)
    })
  },
  getAllTree({ commit }) {
    const param = { status: 'master/privileges/tree' }
    useIPA.get(param).then(response => {
      const privilegeTree = {
        rows: response.data.data,
      }
      commit('setDataTree', { ...privilegeTree })
    })
  },
  getById({ commit }, id) {
    return new Promise((resolve, reject) => {
      const param = { status: `master/privilege/${id}` }
      useIPA.get(param).then(response => {
        resolve(response.data.data)
      })
    })
  },
  formPostPut({ commit }, formData, formTable) {
    return new Promise((resolve, reject) => {
      const rawData = {
        parent_id: parseInt(formData.select_1),
        level: parseInt(formData.text_2),
        order: parseInt(formData.text_8),
        code: formData.text_3,
        name: formData.text_4,
        icon: formData.text_5,
        slug: formData.text_6,
        url: formData.text_7,
        // privilege:[
        //   {
        //     code: formTable.code,
        //     name: formTable.name
        //   }
        // ]
      }
      const param = { rawData, url: 'internal/master/privilege', id: formData.id }
      useIPA.postput(param)
        .then(response => {
          router.push({ name: 'privilege-category' })
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        })
    })
  },
  remove({ commit }, id) {
    return new Promise((resolve, reject) => {
      const param = { url: 'internal/master/privilege/', id }
      useIPA.delete(param)
        .then(response => {
          if (response.data.hasErrors) {
            reject(response.data.message)
          } else {
            resolve(response.data)
          }
        },
        error => {
          if (error.response.data.hasOwnProperty('hasErrors')) {
            reject(error.response.data.message)
          } else {
            reject(error.message)
          }
        })
    })
  },
}

// mutations
const mutations = {
  setData(state, privilegeCategory) {
    state.items = privilegeCategory.rows
    state.totalRows = privilegeCategory.rows.length
    state.options = []
    for (let i = 0; i < privilegeCategory.rows.length; i++) {
      const option = []
      for (const key in privilegeCategory.rows[i]) {
        if (key === 'id') {
          option.value = privilegeCategory.rows[i][key]
        } else if (key === 'name') {
          option.title = privilegeCategory.rows[i][key]
        } else if (key === 'id') {
          option.oid = privilegeCategory.rows[i][key]
        }
      }
      state.options.push({ ...option })
    }
  },
  setPagination(state, pagination) {
    state.perPage = pagination.limit
    state.totalRows = pagination.total_items
  },
  setDataTree(state, privilegeTree) {
    state.itemsTree = privilegeTree.rows
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
